export default __webpack_public_path__ + "static/media/i_bus-tro_pp.d7979dff.svg";